export default __webpack_public_path__ + "static/media/mozart4.c2e4563e.png";